export default __webpack_public_path__ + "static/media/iotb1.e21fdf8c.avif";